import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=6ce857fe&scoped=true&"
import script from "./PermissionPage.vue?vue&type=script&lang=js&"
export * from "./PermissionPage.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPage.vue?vue&type=style&index=0&id=6ce857fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce857fe",
  null
  
)

export default component.exports